<template>
  <AdsTemplate>
    <div id="prematch-page" class="match-list-container">
      <MatchControl
        :filters="filters"
        :sorting="sorting"
        :constants="constants"
        is-changes-only
      />
      <div class="match-list">
        <Pagination
          :page="page"
          :total="matches.total"
          :per-page="perPage"
          @input="page = $event"
        ></Pagination>
        <Match
          v-for="match in matches.data"
          :key="match._id"
          :away="match.away"
          :home="match.home"
          :away-win-coef="match.awayWinCoef"
          :data="match.data"
          :fixed="match.fixed"
          :home-win-coef="match.homeWinCoef"
          :league="match.league"
          :move="match.move"
          :start-time="match.startTime"
          :start="match.start"
          :time="match.time"
          :mini="match.mini"
          :is-favorite="match.isFavorite"
          :time-level-class="match.$timeLevel"
          :home-level-class="match.$homeLevel"
          :away-level-class="match.$awayLevel"
          :data-companies="match.dataCompanies"
          @view="toggleMatchView(match._id)"
          @favorite="setFavoriteMatch(match._id)"
        />
        <Pagination
          :page="page"
          :total="matches.total"
          :per-page="perPage"
          @input="page = $event"
        ></Pagination>
      </div>
    </div>
  </AdsTemplate>
</template>

<script>
import AdsTemplate from "@/views/AdsTemplate.vue";
import Pagination from "@/components/Pagination.vue";
import Match from "@/components/PrematchMatch.vue";
import { MatchUtil } from "@/store/utils";
import MatchControl from "../components/common/MatchControl.vue";
import { MATCH_FILTER_KEYS } from "../store/utils/constant";

const { SORT_TYPES, FETCH_STATUS } = MatchUtil;
const CATEGORY = "prematch";
const filters = [MATCH_FILTER_KEYS.ALL, MATCH_FILTER_KEYS.FAVORITES];
const sorting = [SORT_TYPES.TIME, SORT_TYPES.TOTAL, SORT_TYPES.HANDICAP];

export default {
  name: "Prematch",
  components: { Match, AdsTemplate, Pagination, MatchControl },
  data() {
    return {
      page: 1,
      perPage: 20,
      fetchTimeout: null,
      maxHistory: 3,
      constants: { CATEGORY, MATCH_FILTER_KEYS },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    state() {
      return this.$store.state[CATEGORY];
    },
    filters() {
      return this.$store.getters.prematchFilters(filters);
    },

    sorting() {
      return this.$store.getters.prematchSorting(sorting);
    },
    matches() {
      const opts = { page: this.page, perPage: this.perPage };
      return this.$store.getters.prematchMatches(opts);
    },
  },
  async mounted() {
    this.$store.commit("SET_PREMATCH_SORT", {
      type: SORT_TYPES.TIME,
      order: "ASC",
    });
    this.state.fetchStatus = FETCH_STATUS.ACTIVE;
    this.fetchDataPeriodically();
  },
  beforeUnmount() {
    this.state.fetchStatus = FETCH_STATUS.NON_ACTIVE;
    clearTimeout(this.fetchTimeout);
    this.$store.commit("updateSearchText", { value: "", category: CATEGORY });
  },
  methods: {
    toggleMatchView(id) {
      // A-9: гейтинг на контроле (<Lock> в HeaderMatch), здесь только действие
      this.$store.commit("TOGLE_PREMATCH_EXPANDED", id);
    },
    setFavoriteMatch(id) {
      this.$store.dispatch("toggleFavorite", id);
    },
    fetchDataPeriodically() {
      this.$store.dispatch("getPrematchMatches").catch(console.error);
      this.fetchTimeout = setInterval(() => {
        this.$store.dispatch("getPrematchMatches").catch(console.error);
      }, 300000); // 300000 мілісекунд = 5 хвилин
    },
  },
};
</script>

<style lang="scss" scoped>
#prematch-page {
  margin-top: 0.75rem;
}
</style>
